export default __webpack_public_path__ + "static/hero-ee456ce6c3559a958ddfa7126d8c5300.svg";